export default __webpack_public_path__ + "static/media/bootstrap.033bbdea.svg";